/*------------experience header----------------*/

$(window).scroll(function() {    
    var scroll = $(window).scrollTop();

    if (scroll >= 50) {
        $("#shopify-section-header").addClass("fixedHeader");
    } else {
        $("#shopify-section-header").removeClass("fixedHeader");
    }
});